import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Server from "../Server.js";
import Header from "../Header.js";
import { Message } from 'primereact/message';
import { Tag } from 'primereact/tag';
import { Divider } from 'primereact/divider';
import { Button } from "primereact/button";
import { Card } from 'primereact/card';
import { Toast } from "primereact/toast";
import "@hassanmojab/react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "@hassanmojab/react-modern-calendar-datepicker";
import { ProgressSpinner } from "primereact/progressspinner";
import './travel.css';

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.Server = new Server();
    const params = new URLSearchParams(window.location.href);
    this.state = {
      firstAirPort: params.get("firstAirPort"),
      lastAirPort: params.get("lastAirPort"),
      number: params.get("number"),
      departureDate: params.get("departureDate"),
      returnDate: params.get("returnDate"),
      DepartureFlights: [],
      url: this.Server.getUrl(),
      ShowLoading: true
    };
  }
  componentDidMount() {
    this.searchOneDayIntrnal();
  }

  searchOneDayIntrnal() {
    let that = this;
    let path = "";/*"http://localhost:3000/TravelApi/internalFlight_oneWay";*/
     if(!this.state.returnDate)
        path = "https://ansarcrm.iran.liara.run/TravelApi/internalFlight_oneWay"
     else
        path = "https://ansarcrm.iran.liara.run/TravelApi/internalFlight_twoWay"
    this.Server.send(
      path,
      {
        firstAirPort: this.state.firstAirPort,
        lastAirPort: this.state.lastAirPort,
        number: this.state.number,
        departureDate: this.state.departureDate,
        returnDate: this.state.returnDate ? this.state.returnDate : null
      },
      function (response) {  

        
        const DepartureFlights = response.data.DepartureFlights.map((item)=>{
          return {
            'Airline': {
              Name: item.AirLine
            },
            'Departure': {
              ParentRegion : {
                FaRegionName : item.AirportOfOrigin
              }
            },
            'Arrival': {
              ParentRegion : {
                FaRegionName: item.AirportOfDestination
              }
            },
            'FlightType': "",
            "FlightID": item.FlightID,
            "AdtPrice": item.AdtPrice,
            "ChdPrice": item.ChdPrice,
            "InfPrice": item.InfPrice,
            "DepartureTime" : `${item.HoursGo}:${item.HoursBack}` ,
            "ArrivalTime":  `${item.HoursGo}:${item.minutesBack}` ,
            "shantia" : true
          }
      })

      const ReturnFlights =  response.data.ReturnFlights ?  response.data.ReturnFlights.map((item)=>{
        return {
          'Airline': {
            Name: item.AirLine
          },
          'Departure': {
            ParentRegion : {
              FaRegionName : item.AirportOfOrigin
            }
          },
          'Arrival': {
            ParentRegion : {
              FaRegionName: item.AirportOfDestination
            }
          },
          'FlightType': "",
          "FlightID": item.FlightID, 
          "AdtPrice": item.AdtPrice,
          "ChdPrice": item.ChdPrice,
          "InfPrice": item.InfPrice,
          "DepartureTime" : `${item.HoursGo}:${item.HoursBack}` ,
          "ArrivalTime":  `${item.HoursGo}:${item.minutesBack}` ,
          "shantia" : true
        }
    }) : [];
    debugger;
        that.setState({
          ShowLoading: false,
          DepartureFlights : (DepartureFlights||[]).concat(that.state.DepartureFlights||[]),
          ReturnFlights: that.state.returnDate ? (ReturnFlights||[]).concat(that.state.ReturnFlights||[]) : [],

        },()=>{
          that.searchOneDayApi();
        });
      },
      function () {
        that.setState({
          ShowLoading: false,
        });
        that.searchOneDayApi();
      },
      true
    );
  }

  searchOneDayApi() {
    let that = this;
    let path = "";
    if(!this.state.returnDate)
       path = "TravelApi/hiholiday_oneWay"
    else
       path = "TravelApi/hiholiday_twoWay"
    this.Server.send(
      path,
      {
        firstAirPort: this.state.firstAirPort,
        lastAirPort: this.state.lastAirPort,
        number: this.state.number,
        departureDate: this.state.departureDate,
        returnDate: this.state.returnDate ? this.state.returnDate : null
      },
      function (response) {
        debugger;
        that.setState({
          ShowLoading: false,
          DepartureFlights: response.data.result ? (that.state.DepartureFlights||[]).concat(response.data.result.DepartureFlights||[]) : [],
          ReturnFlights: response.data.result ? (that.state.ReturnFlights||[]).concat(response.data.result.ReturnFlights||[]) : [],
          message: ((response.data.result && response.data.result.DepartureFlights.length == 0 ) &&  that.state.DepartureFlights.length === 0) ? response.data.result.Message || "No Data" : null,
          messageType: response.data.result && response.data.result.Type ? (response.data.result.Type == "Error" ? "error" : "info") : "info",
        });
      },
      function () {
        that.setState({
          ShowLoading: false,
        });
      }
    );
  }

  Revalidate(FlightID, Shantia) {
    let that = this;
    let path = "";
    if(Shantia){
      FlightID = "TravelApi/Revalidate";
    }else{
      FlightID = "TravelApi/Revalidate";
    }
    this.Server.send(
      path,
      {},
      function (response) {  
        that.setState({
          ShowLoading: false,
        })
      },
      function () {
        that.setState({
          ShowLoading: false,
        });
      }
    );
    
  }

  render() {
    return (
      <div style={{ height: "100%" }}>
        <Header ComponentName="سفر" ComponentLName="app-icon-15" />

        {!this.state.ShowLoading ? (
          <div
            className="sarv-bg1 sarv-home-top-box"
            style={{  direction: "rtl",background:'#eee' }}
          >
          {
            this.state.message ?
                <div style={{display:'flex', justifyContent:'center'}} >
                    <Message severity={this.state.messageType} text={this.state.message} style={{width:'100%'}}></Message>
                </div>
            :
                <div>
                    {this.state.DepartureFlights.map((item,index)=>{
                        return(
                            <div style={{marginBottom:10,padding:5}} key={index}>
                                <Card >
                                    <div style={{position:'relative'}}>
                                            {item.shantia &&
                                               <Tag style={{position:'absolute',right:0,top:-20}} severity={"success"} >شنتیا</Tag>
                                            }

                                            
                                        <div style={{display:'flex',justifyContent:'space-between'}}>
                                            
                                            <div style={{display:'flex'}}>

                                            <span><img src={item.Airline.Logo} style={{width:38}} /></span>    
                                            <span><span>هواپیمایی </span><span>{item.Airline.Name}</span></span> 
                                            
                                            </div>
                                        <span style={{borderRadius:2,padding:5,fontSize:11}}>{item.FlightType == "Charter" ? "چارتری" : "سیستمی"} </span>

                                        </div>   
                                        <div style={{textAlign:'end',marginBottom:20}}>
                                            <span style={{fontSize:14}} className="mr-2">{item.PersianDepartureDate}</span>
                                        </div>
                                       
                                        <div style={{display:'flex',justifyContent:'space-evenly'}}>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <span style={{textAlign:'center'}}>{item.DepartureTime}</span>
                                                <span style={{textAlign:'center',color: 'var(--bluegray-200)'}}>{item.Departure.ParentRegion.FaRegionName}</span>
                                            </div>
                                            <h5 className="travel-date "></h5>

                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <span style={{textAlign:'center'}}>{item.ArrivalTime}</span>
                                                <span style={{textAlign:'center',color: 'var(--bluegray-200)'}} >{item.Arrival.ParentRegion.FaRegionName}</span>

                                            </div>

                                        </div>
                                            <div style={{display: 'flex', justifyContent: "space-between"}}>
                                            {item.Capacity && 
                                            <div style={{display: 'flex', justifyContent: "left"}} >
                                               <Tag  severity={"success"} >ظرفیت : {item.Capacity} نفر</Tag>
                                            </div>
                                            } 
                                            {item.Supplier && 
                                            <div style={{display: 'flex', justifyContent: "left"}} >
                                              <Tag  severity={"default"} >{item.Supplier.Name}</Tag>
                                            </div>
                                            } 
                                            
                                            </div>
                                          
                                    </div>
                                    

                                    {this.state.returnDate && this.state.ReturnFlights[index] &&
                                            <div style={{marginTop:40}}>
                                                <Divider />
                                        <div style={{display:'flex',justifyContent:'space-between'}}>
                                        <div  style={{display:'flex'}}>
                                        <span><img src={this.state.ReturnFlights[index].Airline.Logo} style={{width:38}} /></span>    
                                        <span><span>هواپیمایی </span><span>{this.state.ReturnFlights[index].Airline.Name}</span></span> 
                                        </div>    
                                        
                                        <span style={{borderRadius:2,padding:5,fontSize:11}}>{item.FlightType == "Charter" ? "چارتری" : "سیستمی"} </span>
                                        </div>
                                        <div style={{textAlign:'end',marginBottom:20}}>
                                            <span style={{fontSize:14}} className="mr-2">{this.state.ReturnFlights[index].PersianDepartureDate}</span>
                                        </div>
                                        <div style={{display:'flex',justifyContent:'space-evenly'}}>
                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <span style={{textAlign:'center'}}>{this.state.ReturnFlights[index].DepartureTime}</span>
                                                <span style={{textAlign:'center',color: 'var(--bluegray-200)'}}>{this.state.ReturnFlights[index].Departure.ParentRegion.FaRegionName}</span>
                                            </div>
                                            <h5 className="travel-date return"></h5>

                                            <div style={{display:'flex',flexDirection:'column'}}>
                                                <span style={{textAlign:'center'}}>{this.state.ReturnFlights[index].ArrivalTime}</span>
                                                <span style={{textAlign:'center',color: 'var(--bluegray-200)'}} >{this.state.ReturnFlights[index].Arrival.ParentRegion.FaRegionName}</span>

                                            </div>

                                        </div>
                                        <div style={{display: 'flex', justifyContent: "space-between"}}>
                                            {item.Capacity && 
                                            <div style={{display: 'flex', justifyContent: "left"}} >
                                               <Tag  severity={"success"} >ظرفیت : {item.Capacity} نفر</Tag>
                                            </div>
                                            } 
                                            {item.Supplier && 
                                            <div style={{display: 'flex', justifyContent: "left"}} >
                                              <Tag  severity={"default"} >{item.Supplier.Name}</Tag>
                                            </div>
                                            } 
                                            
                                            </div>
                                        </div>
                                     }
                                     <Divider />


                                    <div style={{display:'flex',justifyContent:'space-between', alignItems:'center'}}>
                                    <div  style={{display:'flex',flexDirection:'column'}}>
                                        <span style={{color: 'var(--bluegray-200)',fontSize:13}}>برای یک نفر</span>
                                        {this.state.returnDate && this.state.ReturnFlights[index] ?
                                            <span>
                                            <span style={{fontWeight:'bold',fontSize:18}}>{
                                            item.AdtPrice && this.state.ReturnFlights[index].AdtPrice && (parseInt(item.AdtPrice) + parseInt(this.state.ReturnFlights[index].AdtPrice)).toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                            }</span>
                                            <span style={{fontSize:13}}> تومان</span>
                                            </span>
                                        :
                                        <span>
                                            <span style={{fontWeight:'bold',fontSize:18}}>{

                                            item.AdtPrice && item.AdtPrice.toString().replace(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                            
                                            }</span>
                                            <span style={{fontSize:13}}> تومان</span>
                                        </span>
                                        }
                                    </div>
                                    <div>
                                    <Button label="انتخاب" className=" p-button-info" onClick={()=>{
                                      const FlightID = item.FlightID;
                                      this.Revalidate(FlightID,item.shantia);
                                    }} />

                                    </div>
                                    </div>
                                    
                                </Card>
                            </div>
                        )
                    })}
                </div>
          }
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(Search);
